import dateFormat from 'date-fns/format';
import isDate from 'date-fns/isValid';
import formatUSD from './formatUSD';

export default {
  usd: formatUSD,
  ssn: value => {
    const pattern = /^(\d{3})-?(\d{2})-?(\d{4})$/;
    const matches = value.match(pattern);
    if (!matches) {
      return null;
    }
    return matches.slice(-3).join('-');
  },
  sin: value => {
    const pattern = /^(\d{3})-?(\d{3})-?(\d{3})$/;
    const matches = value.match(pattern);
    if (!matches) {
      return null;
    }
    return matches.slice(-3).join('-');
  },
  // value must be a date object
  date: (value, format = 'MM/dd/yyyy') => {
    if (typeof value === 'string') return null;
    return isDate(value) ? dateFormat(value, format) : null;
  },
  capitalize: value => value[0].toUpperCase() + value.slice(1).toLowerCase(),
  humanize: str =>
    str.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
  formatEIN: ein => {
    const pattern = /(\d{2})-?(\d{7})$/;
    if (ein === null || ein === undefined) {
      return '';
    }
    const matches = ein.match(pattern);
    if (!matches) {
      return '';
    }
    return matches.slice(-2).join('-');
  },
};
